<script>
export default {
  name: 'Affiliates',
  computed: {
    meitavAffiliates() {
      return this.$route.query.affId === 'meitav' || this.$route.query.affId === 'meitav-plus';
    },
    affiliateId() {
      return this.$route.query.affId;
    },
  },
};
</script>
